import http from './http';
import {USER_BASE} from './paths';
import { getSessionInfo } from '../utils/sessionUtils';

const userApi = {
  // 회원가입
  signup: (userData) => {
    return http.post(`${USER_BASE}`, userData);
  },

  // 로그인
  login: (loginData) => {
    const sessionInfo = getSessionInfo();
    return http.post(`${USER_BASE}/login`, {
      ...loginData,
      sessionId: sessionInfo.sessionId,
      deviceName: sessionInfo.deviceName
    });
  },

  // 회원정보 수정
  updateUser: (userId, userData) => {
    return http.patch(`${USER_BASE}/${userId}`, userData);
  },

  // 회원 탈퇴
  deleteUser: (userId) => {
    return http.delete(`${USER_BASE}/${userId}`);
  },

  // 로그아웃
  logout: (userId) => {
    return http.post(`${USER_BASE}/${userId}/logout`);
  },

  // 전체 사용자 목록 조회
  listUsers: () => {
    return http.get(`${USER_BASE}`).then((res) => res.data);
  },

  // 활성 세션 목록 조회
  getActiveSessions: (userId, currentSessionId) => {
    const params = currentSessionId ? { currentSessionId } : {};
    return http.get(`${USER_BASE}/${userId}/sessions`, { params });
  },

  // 특정 세션 로그아웃
  logoutSession: (userId, sessionId) => {
    return http.post(`${USER_BASE}/${userId}/sessions/logout`, { sessionId });
  },

  // 모든 세션 로그아웃 (현재 세션 제외)
  logoutAllSessions: (userId, exceptSessionId) => {
    const params = exceptSessionId ? { exceptSessionId } : {};
    return http.post(`${USER_BASE}/${userId}/sessions/logout-all`, null, { params });
  },
};

export default userApi;
